import { render, staticRenderFns } from "./PayrollInstanceCorporateTable.vue?vue&type=template&id=1ba75df2&lang=pug"
import script from "./PayrollInstanceCorporateTable.vue?vue&type=script&lang=js"
export * from "./PayrollInstanceCorporateTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports